import { useEffect, useState } from "react";
import { PopUp } from "../PopUp";

const missionText = [
  "Welcome to Claim Defender A.I. – The Ultimate Insurance Ops Game.",
  "🎯 YOUR MISSION:",
  "Take on the most ruthless force in the corporate jungle — insurance companies.",
  "Your mission, should you choose to accept it, is to secure MAXIMUM PAYOUTS in RECORD TIME using nothing but your brain, your boldness, and our Claim Defender A.I. system.",
  "🚨 CRITICAL MISSION DIRECTIVE:",
  "Use the Claims Progression Matrix to increase your progression percentage every week",
  "Track claim timelines with hawk-eye precision",
  "Lodge AFCA complaints immediately if an insurer breaches 10-business-day or 30-calendar-day deadlines",
  "Hold insurers accountable with consistent follow-up",
  "Apply daily pressure — because time is money, and pressure is power",
  "🧠 SCORING SYSTEM (Updated):",
  "Action  Points",
  "Record a Procedural Breach (with evidence)  +2000 pts, Win an AFCA Appeal  +1000 pts, Early Claim Settlement (under 50 days)  +500 pts, 5-Star Google Review Logged  +500 pts, Client Video Testimonial Secured  +1000 pts, Daily Pressure (log in each day)  +20 pts per day, Secure a Variation Egg (Approved):  +10% of total egg payout",
  "🏝 ANNUAL REWARDS (DECEMBER):",
  "🏆 Top Agent: 4 weeks Bonus + All-expenses-paid 5-star tropical island holiday (Philippines)",
  "🥈 2nd & 3rd Place: 3 Week Bonus + Mystery Prizes (valued and insane 🤯)",
  "This message will self-destruct once the insurer caves.",
  "Until then, Agent... apply pressure, escalate hard, and hatch those eggs.",
  "Ready to play? 🎮.",

];

export default function MissionBriefing() {
  const [animatingLines, setAnimatingLines] = useState([]);
  const [countdown, setCountdown] = useState(12);
  const [isSoundOn, setIsSoundOn] = useState(false);
  const [visibleStatus, setVisibleStatus] = useState(true);
  // const [audio] = useState(
  //   new Audio("/sounds/video-game-music-loop-27629.mp3")
  // );

  // Animation duration in milliseconds
  const animationDuration = 500;
  // Time to wait before starting the first line (reduced)
  const initialDelay = 300;
  // Time to wait before starting the next line (reduced to 1/3 of animation duration)
  const lineDelay = animationDuration / 3;

  useEffect(() => {
    // Start the first line after initial delay
    const firstLineTimer = setTimeout(() => {
      setAnimatingLines([0]);
    }, [initialDelay]);

    // Set up timers for each subsequent line
    const timers = [];

    for (let i = 1; i < missionText.length; i++) {
      const delay = initialDelay + lineDelay * i;

      const timer = setTimeout(() => {
        setAnimatingLines((prev) => [...prev, i]);
      }, delay);

      timers.push(timer);
    }

    // Start countdown timer after all lines have started animating
    const totalAnimationTime =
      initialDelay + lineDelay * missionText.length + animationDuration;

    const countdownTimer = setTimeout(() => {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }, totalAnimationTime);

    // const handleUserInteraction = () => {
    //   if (!isSoundOn) {
    //     audio.loop = true;
    //     audio
    //       .play()
    //       .catch((error) => console.error("Audio play failed:", error));
    //     setIsSoundOn(true);
    //   }

    //   document.removeEventListener("click", handleUserInteraction);
    // };

    // document.addEventListener("click", handleUserInteraction);

    // Clean up all timers
    return () => {
      clearTimeout(firstLineTimer);
      timers.forEach((timer) => clearTimeout(timer));
      clearTimeout(countdownTimer);
      // document.removeEventListener("click", handleUserInteraction);
    };
  }, [lineDelay]);

  const handleSoundToggle = () => {
    if (!isSoundOn) {
      setIsSoundOn(true);
      // audio.play();
    } else {
      setIsSoundOn(false);
      // audio.pause();
    }
    // Sound logic would go here in a real implementation
  };

  const handleSkipMission = (event) => {
    // audio.pause();
    setIsSoundOn(false);
    setVisibleStatus(false);
  };

  return (
    <>
      <div
        className={`${
          visibleStatus ? "flex" : "hidden"
        } absolute w-full max-w-4xl bg-black border-2 border-green-500 rounded-xl p-6 font-mono text-green-500 cursor-pointer flex-col gap-y-8 opacity-[0.95]`}
        onClick={handleSoundToggle}
      >
        <div className="flex justify-between">
          <p>G'day, Special Agent! 🔔</p>
          <button
            onClick={handleSkipMission}
            className="bg-red-500 p-2 rounded text-white text-xs"
          >
            Skip Mission
          </button>
        </div>

        <div className="space-y-1">
          {missionText.map((text, index) => {
            const textColor = "#22c55e";
            const isAnimating = animatingLines.includes(index);

            return (
              <div key={index} className="relative overflow-hidden">
                <p
                  className="terminal-line"
                  style={{
                    width: isAnimating ? "100%" : "0%",
                    opacity: isAnimating ? 1 : 0,
                    color: textColor,
                    borderRight: "2px solid",
                    borderRightColor: textColor,
                    paddingRight: "4px",
                    transition: `width ${animationDuration}ms ease-in-out, opacity ${animationDuration}ms ease-in-out`,
                    animation: isAnimating
                      ? "border-blink 0.5s infinite"
                      : "none",
                  }}
                >
                  {text}
                </p>
              </div>
            );
          })}
        </div>

        <p className="text-yellow-400 text-center">
          Click anywhere for sound 🔊
        </p>

        {countdown < 12 && (
          <div className="mt-4 text-red-500 text-center">
            This message will self-destruct in {countdown} seconds...
          </div>
        )}
      </div>
      <div className={`${visibleStatus ? "hidden" : "block"}`}>
        <PopUp />
      </div>
    </>
  );
}
